import 'css-chunksrc/client/pages/zonesPage/zonesPage/heading/styles.scss';export default {
  "heading": "_heading_exxtm_1"
};